<div class="wrapper">
  <div class="container-my">
    <div class="screen">
      <div class="screen__content">
        <ng-container *ngIf="!registerToggle">
          <form class="login">
            <p style="color:red" *ngIf='!loginIsValid'>Wrong details, please check</p>
            <div class="login__field">
              <!-- <i class="login__icon fas fa-user"></i> -->
              <input type="text" class="login__input" placeholder="Phone" [(ngModel)]="login.username"
                [ngModelOptions]="{standalone: true}">
            </div>
            <div class="login__field">
              <!-- <i class="login__icon fas fa-lock"></i> -->
              <input (keydown.enter)='onSubBtnClick()' type="password" class="login__input" placeholder="Password"
                [(ngModel)]="login.password" [ngModelOptions]="{standalone: true}">
            </div>

            <div class="">
              <!-- <i class="login__icon fas fa-lock"></i> -->
              <a class="fg" routerLink="/physical-user/forgot-password">Forgot password?</a>
            </div>
            <div class="btns">
              <button class="button login__submit" [disabled]='loadingToggle' (click)='onSubBtnClick()'>
                <span class="button__text">Log In</span>
                <i class="button__icon fas fa-chevron-right"></i>
              </button>
              <button class="button login__submit" (click)="toggle()">
                <span class="button__text">Register</span>
                <i class="button__icon fas fa-chevron-right"></i>
              </button>
            </div>

          </form>
        </ng-container>
        <ng-container>
          <form [formGroup]="registerForm" class="login reg" [ngClass]="{'acode': booleanForCode}"
            *ngIf="registerToggle">
            <div class="fields" *ngIf="!booleanForCode">
              <div class="login__field">
                <input type="text" class="login__input" placeholder="First name" formControlName="firstName">
              </div>
              <div class="login__field">
                <input type="text" class="login__input" placeholder="Last name" formControlName="lastname">
              </div>
              <div class="login__field">
                <input type="password" class="login__input" placeholder="Password" formControlName="password">
              </div>
              <div class="login__field">
                <input type="password" class="login__input" placeholder="Confirm password"
                  formControlName="confirmPassword">
              </div>
              <div class="login__field">
                <input type="text" class="login__input" placeholder="Phone number" formControlName="phoneNumber">
              </div>
              <div class="btns">
                <button class="button login__submit" (click)="toggleBack()">
                  <span class="button__text">Back</span>
                  <i class="button__icon fas fa-chevron-right"></i>
                </button>
                <button class="button login__submit" (click)="register()">
                  <span class="button__text">Register</span>
                  <i class="button__icon fas fa-chevron-right"></i>
                </button>
              </div>
            </div>

            <div class="code" *ngIf="booleanForCode">
              <h1>Activation code</h1>
              <code-input [isCodeHidden]="false" [codeLength]="5" (codeChanged)="onCodeChanged($event)"
                (codeCompleted)="onCodeCompleted($event)" inputmode='none'>
              </code-input>
              <h3 class="mt" *ngIf='!showTimeLeft' (click)='getActivationCode()' class="getCode-wrapper">
                Get new activation code
              </h3>
              <h3 class="mt" *ngIf='showTimeLeft'>
                {{getTimeLeft()}}
              </h3>
              <div class="btns">
                <!-- <button class="button login__submit" (click)="toggleBack()">
                  <span class="button__text">Activate</span>
                  <i class="button__icon fas fa-chevron-right"></i>
                </button> -->
              </div>
            </div>



          </form>
        </ng-container>

        <div class="social-login" *ngIf="!registerToggle">
          <h3>Log in as</h3>
          <div class="social-icons">
            <a class="pxuser" routerLink="">Merchant</a>
          </div>
        </div>
      </div>
      <div class="screen__background">
        <span class="screen__background__shape screen__background__shape4"></span>
        <span class="screen__background__shape screen__background__shape3"></span>
        <span class="screen__background__shape screen__background__shape2"></span>
        <span class="screen__background__shape screen__background__shape1"></span>
      </div>
    </div>
  </div>
</div>

<app-success *ngIf='successToggle' [text]='"Your registration complited"' (ok)='onOkClick()'></app-success>
